var _defs, _path, _path2, _rect, _path3, _path4, _path5, _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b0430484-81d7-44fe-b30a-e92097e43d69",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ab01b52c-2712-4570-b2ac-187bb37cacd2,.ac8aae63-299c-4ca2-8f42-b3fd86eff862,.e0092723-fd92-4ee7-8cd8-b73ebdb98843{fill:none;}.e0092723-fd92-4ee7-8cd8-b73ebdb98843,.fe052e98-913a-42cc-a64e-5675f571092f{stroke:#8e8e8e;}.ac8aae63-299c-4ca2-8f42-b3fd86eff862,.e0092723-fd92-4ee7-8cd8-b73ebdb98843,.fe052e98-913a-42cc-a64e-5675f571092f{stroke-linecap:round;}.ab01b52c-2712-4570-b2ac-187bb37cacd2,.ac8aae63-299c-4ca2-8f42-b3fd86eff862,.e0092723-fd92-4ee7-8cd8-b73ebdb98843,.fe052e98-913a-42cc-a64e-5675f571092f{stroke-linejoin:round;stroke-width:2px;}.fc1d3b2b-08f8-441b-a74b-35b266b84f89,.fe052e98-913a-42cc-a64e-5675f571092f{fill:#1495c1;}.e5e381ef-87ff-428e-87d9-cf4d8aa59faa{fill:#fff;}.ab01b52c-2712-4570-b2ac-187bb37cacd2,.ac8aae63-299c-4ca2-8f42-b3fd86eff862{stroke:#645346;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dll") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e0092723-fd92-4ee7-8cd8-b73ebdb98843",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fe052e98-913a-42cc-a64e-5675f571092f",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fc1d3b2b-08f8-441b-a74b-35b266b84f89",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e5e381ef-87ff-428e-87d9-cf4d8aa59faa",
    d: "M43.9,62.4a11,11,0,0,1,2.7-.2,5.9,5.9,0,0,1,4.1,1.2A4.6,4.6,0,0,1,52.1,67a5.7,5.7,0,0,1-1.4,4,6.5,6.5,0,0,1-4.5,1.4H43.9Zm1.3,8.9h1.3c2.8,0,4.3-1.6,4.3-4.3s-1.4-3.9-4.1-3.9H45.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "e5e381ef-87ff-428e-87d9-cf4d8aa59faa",
    d: "M53.8,62.2h1.3v9h4.4v1.1H53.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e5e381ef-87ff-428e-87d9-cf4d8aa59faa",
    d: "M60.9,62.2h1.3v9h4.3v1.1H60.9Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "ac8aae63-299c-4ca2-8f42-b3fd86eff862",
    cx: 46.9,
    cy: 43.8,
    r: 7.7,
    transform: "translate(-7.8 10.2) rotate(-11.5)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 43.7,
    y1: 36.4,
    x2: 42.9,
    y2: 34.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 50.9,
    y1: 53.2,
    x2: 50,
    y2: 51.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 39.4,
    y1: 47,
    x2: 37.5,
    y2: 47.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 56.3,
    y1: 39.9,
    x2: 54.4,
    y2: 40.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 39.4,
    y1: 40.8,
    x2: 37.4,
    y2: 40
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 56.3,
    y1: 47.7,
    x2: 54.4,
    y2: 46.9
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 43.8,
    y1: 51.4,
    x2: 43,
    y2: 53.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 50.7,
    y1: 34.4,
    x2: 49.9,
    y2: 36.3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 43.7,
    y1: 36.4,
    x2: 42.9,
    y2: 34.4
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 50.9,
    y1: 53.2,
    x2: 50,
    y2: 51.3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 39.4,
    y1: 47,
    x2: 37.5,
    y2: 47.8
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 56.3,
    y1: 39.9,
    x2: 54.4,
    y2: 40.7
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 39.4,
    y1: 40.8,
    x2: 37.4,
    y2: 40
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 56.3,
    y1: 47.7,
    x2: 54.4,
    y2: 46.9
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 43.8,
    y1: 51.4,
    x2: 43,
    y2: 53.3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    x1: 50.7,
    y1: 34.4,
    x2: 49.9,
    y2: 36.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ab01b52c-2712-4570-b2ac-187bb37cacd2",
    d: "M44.6,43.8a2.2,2.2,0,0,1,2.3-2.2,2.2,2.2,0,0,1,2.2,2.2,2.3,2.3,0,1,1-4.5,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDll);
export default __webpack_public_path__ + "static/media/dll.1b88dc7b58b955b65fbc7891aa23cb30.svg";
export { ForwardRef as ReactComponent };